import {
  Box,
  Grid,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import { useFormik } from "formik";
import React, { useEffect, useState, useRef } from "react";
import { useDropzone } from "react-dropzone";
import { getAllFileCompressionConfigs } from "src/app-redux/configuration/actions/configurationActions";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import {
  getWeightScanExistingDocuments,
  uploadVehicleScanDocs,
} from "src/app-redux/vehicle/actions/vehicleActions";
import Backdrop from "@material-ui/core/Backdrop";
import {
  currentSelectedIsNodWeightFile,
  currentSelectedVehicleRegNo,
  currentSelectedVehicleScanId,
  loader as vehicleLoader,
} from "src/app-redux/vehicle/vehicleSlice";
import CommonButton from "src/components/CommonButton/CommonButton";
import { useStyles } from "./style";
import Close from "@material-ui/icons/Close";
import IconButton from "@mui/material/IconButton";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import CameraAltIcon from "@material-ui/icons/CameraAlt";
import { downloadFile } from "src/app-redux/common-actions";
import CommonDialog from "src/components/AlertDialog/CommonDialog";
import CommonLoader from "src/components/Loader/CommonLoader";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import moment from "moment";

export interface IDrawerFilesProps {
  refreshDrawer: number;
}

export default function DrawerFiles(props: IDrawerFilesProps) {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const selectedVehicleScanId: any = useAppSelector(currentSelectedVehicleScanId);
  const selectedVehicleRegNo: any = useAppSelector(currentSelectedVehicleRegNo);
  const selectedIsNodWeightFile: any = useAppSelector(currentSelectedIsNodWeightFile);

  const [fileToUpload, setFileToUpload] = React.useState<any[]>([]);
  const [validFileTypes, setValidFileTypes] = React.useState<any>([]);
  const [validFileSize, setValidFileSize] = React.useState(0);
  const [isValidFileType, setIsValidFileType] = React.useState<boolean[]>([]);
  const [isValidFileSize, setIsValidFileSize] = React.useState<boolean[]>([]);
  const loader2: any = useAppSelector(vehicleLoader);

  let fileTypesArr: any[] = [];
  let maxFileSize = 0;
  const [existingFiles, setexistingFiles] = React.useState<any[]>([]);
  const [cameraOpen, setCameraOpen] = useState<boolean>(false);
  const [imageDataURL, setImageDataURL] = useState<any>(null);
  const [cameraNumber, setCameraNumber] = useState(0);
  const playerRef = useRef<HTMLVideoElement | null>(null);

  const onDrop = React.useCallback((acceptedFiles: File[]) => {
    const size: boolean[] = [];
    const type: boolean[] = [];

    acceptedFiles.forEach((file: any) => {
      const split = file.name.split(".");
      type.push(fileTypesArr.includes(`.${split[split.length - 1]}`.toLowerCase()));
      size.push(file.size / (1024 * 1024) <= maxFileSize);
    });

    setIsValidFileSize(size);
    setIsValidFileType(type);
    setFileToUpload(acceptedFiles);
  }, []);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  useEffect(() => {
    getExistingDocs();
    getFileConfig();
  }, []);

  useEffect(() => {
    getExistingDocs();
  }, [props.refreshDrawer]);

  const getExistingDocs = async () => {
    const res: any = await dispatch(
      getWeightScanExistingDocuments({
        id: selectedVehicleScanId,
        isScan: true,
        isNodWeightFile: selectedIsNodWeightFile,
      })
    );
    if (res?.payload?.length) {
      setexistingFiles(res?.payload);
    }
  };

  const getFileConfig = async () => {
    const res: any = await dispatch(getAllFileCompressionConfigs());
    if (res.payload && res.payload[0]) {
      const fileTypes = res.payload[0]?.fileTypes?.split(",").map((type: string) => type.trim());
      setValidFileTypes(fileTypes);
      setValidFileSize(res.payload[0].fileSizeThreshold);
      fileTypesArr = fileTypes;
      maxFileSize = res.payload[0].fileSizeThreshold;
    }
  };

  const formik = useFormik<any>({
    enableReinitialize: true,
    initialValues: {
      vehicleScanId: selectedVehicleScanId,
      registerationNumber: selectedVehicleRegNo,
    },
    onSubmit: async (values: any, actions) => {
      const form = new FormData();
      form.append("vehicleScanId", values.vehicleScanId);
      form.append("registerationNumber", values.registerationNumber);
      fileToUpload.length
        ? fileToUpload.forEach((file) => {
            form.append("files", file);
          })
        : form.append("files", "");

      const res: any = await dispatch(uploadVehicleScanDocs(form));
      if (res.payload) {
        actions.setSubmitting(false);
        formik.resetForm();
        formik.setValues(formik.initialValues);
        setFileToUpload([]);
        setIsValidFileType([]);
        setIsValidFileSize([]);
        getExistingDocs();
        return;
      }
    },
  });

  const removeFileFromIndex = (index: number) => {
    const upload = fileToUpload;
    upload.splice(index, 1);
    setFileToUpload(upload);

    const size: boolean[] = [];
    const type: boolean[] = [];

    fileToUpload.forEach((file: any) => {
      const split = file.name.split(".");
      type.push(validFileTypes.includes(`.${split[split.length - 1]}`));
      size.push(file.size / (1024 * 1024) <= validFileSize);
    });

    setIsValidFileSize(size);
    setIsValidFileType(type);
  };

  // Camera capture functionality
  const dataURLtoFile = (dataurl: any, filename: any) => {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  };

  const getListOfVideoInputs = async () => {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      return devices.filter((device) => device.kind === "videoinput");
    } catch (error) {
      console.error("Error enumerating devices:", error);
      return [];
    }
  };

  const openCamera = async () => {
    setImageDataURL(null);
    setCameraOpen(true);

    if (!("mediaDevices" in navigator)) {
      dispatch(
        addNotificationAction({
          message: "Camera not supported in this browser",
          options: { variant: "error" },
        })
      );
      return;
    }

    if (!("getUserMedia" in navigator.mediaDevices)) {
      dispatch(
        addNotificationAction({
          message: "Camera access not supported in this browser",
          options: { variant: "error" },
        })
      );
      return;
    }

    try {
      const videoInputs = await getListOfVideoInputs();

      if (videoInputs.length === 0) {
        dispatch(
          addNotificationAction({
            message: "The device does not have a camera",
            options: { variant: "error" },
          })
        );
        setCameraOpen(false);
        return;
      }
      if (cameraNumber >= videoInputs.length) {
        console.error("Invalid camera number");
        setCameraOpen(false);
        return;
      }
      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          deviceId: videoInputs[cameraNumber].deviceId
            ? { ideal: videoInputs[cameraNumber].deviceId }
            : undefined,
        },
      });
      if (playerRef.current) {
        playerRef.current.srcObject = stream;
      } else {
        console.error("Video player element not found");
        setCameraOpen(false);
      }
    } catch (error) {
      if (error instanceof Error && error.name === "OverconstrainedError") {
        dispatch(
          addNotificationAction({
            message: "The selected camera is not available. Falling back to the default camera.",
            options: { variant: "warning" },
          })
        );
        try {
          const fallbackStream = await navigator.mediaDevices.getUserMedia({ video: true });
          if (playerRef.current) {
            playerRef.current.srcObject = fallbackStream;
          }
        } catch (fallbackError) {
          dispatch(
            addNotificationAction({
              message: "An error occurred while accessing the camera.",
              options: { variant: "error" },
            })
          );
          setCameraOpen(false);
        }
      } else {
        dispatch(
          addNotificationAction({
            message: "An error occurred while accessing the camera.",
            options: { variant: "error" },
          })
        );
        setCameraOpen(false);
      }
    }
  };

  const closeCamera = () => {
    setImageDataURL(null);
    if (playerRef.current?.srcObject) {
      const tracks = (playerRef.current.srcObject as MediaStream).getTracks();
      tracks.forEach((track) => track.stop());
      playerRef.current.srcObject = null;
    }
    setCameraOpen(false);
  };

  const captureImage = async () => {
    if (!playerRef.current) return;

    const canvas = document.createElement("canvas");
    canvas.width = playerRef.current.videoWidth;
    canvas.height = playerRef.current.videoHeight;
    const context = canvas.getContext("2d");
    if (context) {
      context.drawImage(playerRef.current, 0, 0, canvas.width, canvas.height);
      const imageSrc = canvas.toDataURL();

      // Stop the camera stream
      if (playerRef.current?.srcObject) {
        const tracks = (playerRef.current.srcObject as MediaStream).getTracks();
        tracks.forEach((track) => track.stop());
        playerRef.current.srcObject = null;
      }

      setImageDataURL(imageSrc);
    }
  };

  const confirmAndAddImage = async () => {
    if (!imageDataURL) return;

    // Use validFileTypes state and normalize comparison (trim and lowercase)
    const validTypes = validFileTypes.length > 0 ? validFileTypes : fileTypesArr;
    const normalizedValidTypes = validTypes.map((type: string) => type.trim().toLowerCase());

    // Determine which image extension to use (.jpg or .jpeg) based on what's in allowed types
    let imageExtension = ".jpg";
    if (normalizedValidTypes.includes(".jpeg") && !normalizedValidTypes.includes(".jpg")) {
      imageExtension = ".jpeg";
    } else if (normalizedValidTypes.includes(".jpg")) {
      imageExtension = ".jpg";
    } else if (normalizedValidTypes.includes(".jpeg")) {
      imageExtension = ".jpeg";
    }

    // Convert to file and add to fileToUpload
    const timestamp = moment().format("YYYYMMDD_HHmmss");
    const capturedFile = dataURLtoFile(imageDataURL, `CameraImage_${timestamp}${imageExtension}`);

    // Validate file type and size
    const split = capturedFile.name.split(".");
    const fileExtension = `.${split[split.length - 1]}`.toLowerCase();
    const isValidType = normalizedValidTypes.includes(fileExtension);
    const isValidSize = capturedFile.size / (1024 * 1024) <= validFileSize;

    if (!isValidType) {
      dispatch(
        addNotificationAction({
          message: `Only ${validTypes.join(", ")} files are allowed.`,
          options: { variant: "error" },
        })
      );
      setImageDataURL(null);
      openCamera();
      return;
    }

    if (!isValidSize) {
      dispatch(
        addNotificationAction({
          message: `File size cannot exceed ${validFileSize}MB.`,
          options: { variant: "error" },
        })
      );
      setImageDataURL(null);
      openCamera();
      return;
    }

    // Add to fileToUpload array
    const newFiles = [...fileToUpload, capturedFile];
    setFileToUpload(newFiles);

    // Update validation arrays
    const size: boolean[] = [];
    const type: boolean[] = [];
    newFiles.forEach((file: any) => {
      const fileSplit = file?.name?.split(".");
      const ext = `.${fileSplit[fileSplit.length - 1]}`.toLowerCase();
      const normalizedTypes = validTypes.map((t: string) => t.trim().toLowerCase());
      type.push(normalizedTypes.includes(ext));
      size.push(file.size / (1024 * 1024) <= validFileSize);
    });
    setIsValidFileSize(size);
    setIsValidFileType(type);

    // Close camera and show success message
    closeCamera();
    dispatch(
      addNotificationAction({
        message: "Image captured and added successfully",
        options: { variant: "success" },
      })
    );
  };

  useEffect(() => {
    return () => {
      if (playerRef.current?.srcObject) {
        const tracks = (playerRef.current.srcObject as MediaStream).getTracks();
        tracks.forEach((track) => track.stop());
        playerRef.current.srcObject = null;
      }
    };
  }, []);

  const downloadDocument = async (item: any) => {
    const fileMetaData = {
      url: `${process.env.REACT_APP_API_URL}/get-gate-doc-by-id/${item.id}?docType=2`,
      contentType: ".jpg",
      fileName: item.title,
    };
    dispatch(downloadFile(fileMetaData));
  };

  const [isOpenDailog, setIsOpenDailog] = useState(false);
  const [thumbnailDetails, setThumbnailDetails] = useState<any>({});
  const toggleDialog = async (item: any) => {
    setThumbnailDetails(item);
    setIsOpenDailog(!isOpenDailog);
  };
  return (
    <>
      <Backdrop className={classes.backdrop} open={loader2}>
        <CommonLoader />
      </Backdrop>
      <div className={classes.drawerDetails}>
        {/* Drawer Status Item  */}

        <Grid container spacing={2} className="topContainer" style={{ marginTop: "5px" }}>
          <Grid container direction="row" className="itemRow" spacing={2}>
            {/* File Upload */}
            <Grid item xs={12} md={12}>
              <Box
                {...getRootProps()}
                p={0}
                pl={1}
                border={"1px solid #72CA00"}
                borderRadius={5}
                height={38}
                pb={4}
                overflow={"auto"}
                display={"flex"}
                flexWrap={"wrap"}
                borderColor={isDragActive ? "error.main" : "secondary.main"}
                style={{ cursor: "pointer" }}
              >
                <input {...getInputProps()} />

                {fileToUpload.length ? (
                  fileToUpload.map((file, index) => {
                    return (
                      <div
                        key={file.name}
                        style={{
                          marginTop: "6px",
                          backgroundColor: "#E67817",
                          padding: "3px 15px 3px 5px",
                          borderRadius: "10px",
                          maxWidth: "122px",
                          display: "flex",
                          flexWrap: "wrap",
                          marginLeft: "5px",
                        }}
                      >
                        <div
                          style={{
                            maxWidth: "100px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            fontSize: "11px",
                            color: "white",
                          }}
                        >
                          {file.name}
                        </div>
                        <IconButton
                          aria-label="Search"
                          onClick={(event) => {
                            event.stopPropagation();
                            removeFileFromIndex(index);
                          }}
                          edge="end"
                          className="icon-button-search"
                          style={{
                            color: "white",
                            padding: 0,
                            marginTop: "2px",
                            width: "10px",
                            height: "10px",
                            overflow: "hidden",
                            marginRight: "2px !important",
                          }}
                        >
                          <Close />
                        </IconButton>
                      </div>
                    );
                  })
                ) : isDragActive ? (
                  <p>Drop a file here ...</p>
                ) : (
                  <p style={{ color: "rgb(181 178 178)", marginTop: 9, paddingBottom: 10 }}>
                    {/* Drag and drop file here,or click to select a file */}
                    Upload File
                  </p>
                )}
              </Box>
              <Box>
                <p style={{ color: "#f44336", marginBottom: 0 }}>
                  <ul
                    style={{
                      paddingLeft: "16px",
                      margin: 0,
                      display: isValidFileType.includes(false) ? "block" : "none",
                    }}
                  >
                    <li>
                      Only{" "}
                      {validFileTypes.map((type: any, index: number) => {
                        return index < validFileTypes.length - 1 ? `${type},` : type;
                      })}{" "}
                      files are allowed.
                    </li>
                  </ul>
                  <ul
                    style={{
                      paddingLeft: "16px",
                      margin: 0,
                      display: isValidFileSize.includes(false) ? "block" : "none",
                    }}
                  >
                    <li>File size cannot exceed {validFileSize}MB.</li>
                  </ul>
                </p>
              </Box>
            </Grid>

            <Grid container item xs={12} md={12}>
              <Grid item xs={12} md={12}>
                <Box textAlign="left" mt={1} mb={1}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={openCamera}
                    startIcon={<CameraAltIcon />}
                    style={{ backgroundColor: "#E67817", color: "#fff", marginRight: "8px" }}
                  >
                    Capture Image
                  </Button>
                </Box>
              </Grid>
              <Grid item xs={12} md={9}>
                <Box textAlign="left" mt={1}>
                  <CommonButton
                    cssClass="customSubmitBtn"
                    onClick={() => {
                      formik.resetForm();
                      formik.setValues(formik.initialValues);
                      setFileToUpload([]);
                      setIsValidFileType([]);
                      setIsValidFileSize([]);
                    }}
                  >
                    Reset
                  </CommonButton>
                  <CommonButton
                    cssClass="customSubmitBtn"
                    isGreen
                    disable={!isValidFileType || !isValidFileSize || !fileToUpload.length}
                    onClick={() => {
                      formik.submitForm();
                    }}
                  >
                    Save
                  </CommonButton>
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Grid container direction="row" className="itemRow" spacing={2}>
            <Grid
              item
              md={12}
              id="main-div"
              className={classes.drawerDetails}
              style={{
                height: "max-content",
              }}
            >
              <Grid container direction="column">
                {/* History Item  */}
                {existingFiles.length !== 0 ? (
                  existingFiles.map((item: any) => (
                    <Grid md={6} key={item.id} style={{ padding: "5px" }}>
                      <Grid md={12}>
                        <Box style={{ cursor: "pointer" }} onClick={() => toggleDialog(item)}>
                          <img
                            width="400px"
                            height="200px"
                            src={`data:image/${item?.extension};base64,${item?.base64Image}`}
                            alt={item.extension}
                          />
                        </Box>
                        <Box display="flex">
                          <Grid md={3} style={{ marginTop: "8px" }}>
                            <Typography className="subHeading itemName">
                              {item.originalFileName}
                            </Typography>
                          </Grid>
                          <Grid md={2}>
                            <IconButton
                              onClick={() => {
                                downloadDocument(item);
                              }}
                            >
                              <CloudDownloadIcon />
                            </IconButton>
                          </Grid>
                        </Box>
                        <Box style={{ width: "400px", textAlign: "justify" }}>
                          <Typography className="">
                            <b>Disclaimer:</b> This is a system generated image of the scanned
                            container/vehicle. National Logistics Corporation (NLC) or its staff
                            does not bear any liability of any nature whatsoever, regarding analysis
                            or the contents of this image. NLC is neither responsible nor liable, to
                            analyze/examine/compare/use the content of this scanned image for any
                            purpose even upon request. Scanning is a Non-Intrusive Inspection (NII)
                            and NLC only provides equipment/technical support to carry out the same
                            to Custom or any other Law enforcement agency desirous of doing so. It
                            is the sole responsibility of the requesting party for this (NII) to
                            use/compare/analyze this image to decide the fate of this
                            container/vehicle. NLC is not responsible in any case or under any
                            circumstances, either for the selection of this container/vehicle for
                            (NII) or its hold or release on the basis of the (NII).
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>
                  ))
                ) : (
                  <div></div>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
      <CommonDialog
        isOpen={isOpenDailog}
        handleClose={toggleDialog}
        maxWidth="md"
        heading={"Scanner File Preview"}
      >
        <Box>
          <Box style={{ textAlign: "center" }}>
            <img
              style={{ width: "450px", height: "300px" }}
              src={`data:image/${thumbnailDetails?.extension};base64,${thumbnailDetails?.base64Image}`}
              alt={thumbnailDetails?.extension}
            />
          </Box>
          <Box display="flex">
            <Box mt={1}>
              <Typography className="subHeading itemName">
                {thumbnailDetails?.originalFileName}
              </Typography>
            </Box>
            <Box>
              <IconButton
                onClick={() => {
                  downloadDocument(thumbnailDetails);
                }}
              >
                <CloudDownloadIcon />
              </IconButton>
            </Box>
          </Box>
          <Box style={{ textAlign: "justify" }}>
            <Typography style={{ width: "450px" }}>
              <b>Disclaimer:</b> This is a system generated image of the scanned container/vehicle.
              National Logistics Corporation (NLC) or its staff does not bear any liability of any
              nature whatsoever, regarding analysis or the contents of this image. NLC is neither
              responsible nor liable, to analyze/examine/compare/use the content of this scanned
              image for any purpose even upon request. Scanning is a Non-Intrusive Inspection (NII)
              and NLC only provides equipment/technical support to carry out the same to Custom or
              any other Law enforcement agency desirous of doing so. It is the sole responsibility
              of the requesting party for this (NII) to use/compare/analyze this image to decide the
              fate of this container/vehicle. NLC is not responsible in any case or under any
              circumstances, either for the selection of this container/vehicle for (NII) or its
              hold or release on the basis of the (NII).
            </Typography>
          </Box>{" "}
        </Box>
      </CommonDialog>

      {/* Camera Capture Dialog */}
      <Dialog
        open={cameraOpen}
        onClose={closeCamera}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: {
            backgroundColor: "#000",
          },
        }}
      >
        <DialogTitle style={{ color: "#fff", display: "flex", justifyContent: "space-between" }}>
          <Typography variant="h6">Capture Image</Typography>
          <IconButton onClick={closeCamera} style={{ color: "#fff" }}>
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "400px",
              backgroundColor: "#000",
            }}
          >
            {imageDataURL ? (
              <img
                src={imageDataURL}
                alt="captured"
                style={{ maxWidth: "100%", maxHeight: "500px" }}
              />
            ) : (
              <video
                ref={playerRef}
                autoPlay
                playsInline
                style={{
                  maxWidth: "100%",
                  maxHeight: "500px",
                  backgroundColor: "#000",
                }}
              >
                <track kind="captions" />
              </video>
            )}
          </Box>
        </DialogContent>
        <DialogActions style={{ backgroundColor: "#000", padding: "16px" }}>
          {!imageDataURL && (
            <>
              <Button
                onClick={closeCamera}
                style={{ color: "#fff", marginRight: "8px" }}
                variant="outlined"
              >
                Cancel
              </Button>
              <Button
                onClick={captureImage}
                style={{ backgroundColor: "#E67817", color: "#fff" }}
                variant="contained"
              >
                Capture
              </Button>
            </>
          )}
          {imageDataURL && (
            <>
              <Button
                onClick={() => {
                  setImageDataURL(null);
                  openCamera();
                }}
                style={{ color: "#fff", marginRight: "8px" }}
                variant="outlined"
              >
                Retake
              </Button>
              <Button
                onClick={confirmAndAddImage}
                style={{ backgroundColor: "#E67817", color: "#fff" }}
                variant="contained"
              >
                Add Image
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
}
